import Login from "./pages/Login";
import { createBrowserRouter } from "react-router-dom";
import VenuePreview from "./pages/venue-preview";
// import VenuePreview from "./components/venuePreview/VenuePreview";
import ProtectedRoute from "./hooks/protectRoute";
import VenuesTable from "./components/dashboard/venue-table/venue-table";
import HotelPreview from "./pages/hotel-preview";
import DocPreview from "./pages/doc-Preview";
import GetAllUsers from "./components/dashboard/venue-table/GetAllUsers";
import UserDetails from "./components/dashboard/venue-table/userDetails";
import Customers from "./pages/customers";
import Layout from "./layout";
import NotFoundPage from "./pages/misc/not-found";
import Enquiries from "./pages/enquiries";
import VendorEnquiries from "./pages/vendor-enquiries";
import EnquiryOverview from "./pages/enquiry-overview";

import AddBlog from "./pages/blogs/AddBlog";
import BlogList from "./pages/blogs/BlogsList";
import EditBlog from "./pages/blogs/EditBlog";
import BlogPreview from "./pages/blogs/preview-blog";

import VendorDashboardEditor from "./components/dashboard/vendor-dashboard/VendorDashboardEditor";
import VenueEnquiries from "./pages/venue-enquiry-overview";
import VenueEnquiry from "./pages/venue-enquiries";
import UsersList from "./pages/admin-users/UsersList";
import ContactUsRequests from "./pages/contact-us";
import ChangePassword from "./components/auth/ChangePassword";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import CustomerEnquiries from "./pages/customer-enquiries";
import PaidVendors from "./pages/paid-vendors";
import PinnedListings from "./pages/pinned-listings";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />
  },
  {
    path: "/reset-password",
    element: <ResetPassword />
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/venue-preview/:category/:id",
        element: <ProtectedRoute element={VenuePreview} />,
      },
      {
        path: "/hotel-preview/:category/:id",
        element: <ProtectedRoute element={HotelPreview} />,
      },
      {
        path: "/doc-preview/:category/:id",
        element: <ProtectedRoute element={DocPreview} />,
      },
      {
        path: "/venue-table",
        element: <ProtectedRoute element={VenuesTable} />,
      },
      {
        path: "/allusers",
        element: <ProtectedRoute element={GetAllUsers} />,
      },
      {
        path: "/user-details",
        element: <ProtectedRoute element={UserDetails} />,
      },
      {
        path: "/customers",
        element: <ProtectedRoute element={Customers} />
      },
      {
        path: "/enquiries-vendor",
        element: <ProtectedRoute element={Enquiries} />
      },
      {
        path: "/enquiries-venue",
        element: <ProtectedRoute element={VenueEnquiries} />
      },
      {
        path: "/vendor-enquiries/:vendorId",
        element: <ProtectedRoute element={VendorEnquiries} />
      },
      {
        path: "/venue-enquiries/:venueId",
        element: <ProtectedRoute element={VenueEnquiry} />
      },
      {
        path: "/vendor-enquiry-overview",
        element: <ProtectedRoute element={EnquiryOverview} />
      },
      {
        path: "/vendor-dashboard-editor",
        element: <ProtectedRoute element={VendorDashboardEditor} />
      }
      ,
      {
        path: "/blogs/add",
        element: <ProtectedRoute element={AddBlog} />
      },
      {
        path: "/blogs",
        element: <ProtectedRoute element={BlogList} />
      },
      {
        path: "/blogs/edit/:id",
        element: <ProtectedRoute element={EditBlog} />
      },
      {
        path: "/blogs/:id",
        element: <ProtectedRoute element={BlogPreview} />
      },
      {
        path: "/users",
        element: <ProtectedRoute element={UsersList} />
      },
      {
        path: "/change-password",
        element: <ProtectedRoute element={ChangePassword} />
      },
      {
        path: "/contact-us",
        element: <ProtectedRoute element={ContactUsRequests} />
      },
      {
        path: "/customer-enquiries/:customerId",
        element: <ProtectedRoute element={CustomerEnquiries} />
      },
      {
        path: "/paid-vendors",
        element: <ProtectedRoute element={PaidVendors} />
      },
      {
        path: "/pinned-listings",
        element: <ProtectedRoute element={PinnedListings} />
      },
    ]
  },
  {
    path: "*",
    element: <NotFoundPage />
  }
]);



export default router;
